export default __webpack_public_path__ + "static/media/ic_togo.996d8981.svg";